module.exports = __webpack_public_path__ + "img/DSCN2041.5df5a1ee.jpg";